import type { ResolvedToolDefinition } from "@/data/tools";
import { splitTitle } from "@/lib/utils/title";
import { ShieldCheck } from "lucide-react";
import ToolIcon from "./ToolIcon";

type ToolPageHeaderProps = {
  tool: ResolvedToolDefinition;
};

export default function ToolPageHeader({ tool }: ToolPageHeaderProps) {
  return (
    <header className="text-center space-y-6">
      <div className="inline-flex items-center gap-2 bg-[#f3ecff] border border-[#e9e1ff] text-[#5b32b4] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full">
        <ToolIcon icon={tool.toolType.icon} size={14} />
        {tool.toolType.label}
      </div>

      <h1 className="text-4xl md:text-5xl font-bold text-[#5b32b4]">
        {splitTitle(tool.title ?? tool.name)}
      </h1>

      <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed text-lg">
        {tool.longDescription}
      </p>

      <div className="h-1 w-20 bg-[#fb397d] mx-auto rounded" />
      {tool.heroBadges.length ? (
        <div className="w-full max-w-full">
          <div className="flex flex-row items-center gap-3 pt-2 pb-2 overflow-x-auto scroll-smooth snap-x sm:justify-center [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            {tool.heroBadges.map((badge) => (
              <span
                key={badge}
                className="inline-flex shrink-0 snap-center items-center gap-1.5 text-xs font-semibold text-[#5b32b4] bg-[#f3ecff] border border-[#e9e1ff] px-3 py-1.5 rounded-full whitespace-nowrap"
              >
                <ShieldCheck size={12} className="text-[#c3003a]" />
                {badge}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}
